import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { VivaErrorPopupComponent } from './viva-error-popup.component';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@NgModule({
  declarations: [
    VivaErrorPopupComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    TranslateDirective
  ],
  exports: [
    VivaErrorPopupComponent
  ]
})
export class  VivaErrorPopupModule { }
